<template>
  <div id="app">
    <div id="nav">
      <Header />
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
export default {
  components: {
    Header,
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/scss/variables/mixin.scss";
@import "@/assets/styles/scss/variables/colors.scss";
a {
  border: none;
  text-decoration: none;
}
* {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
}

.container-global {
  padding: 0 30px;
}

body {
  background-color: white;
}

h2 {
  font-weight: 500;
  font-size: 27px !important;
  color: $dark-pink;
  font: normal;
}

.next {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $dark-pink;
  height: 30px;
  width: 30px;
  margin-right: 21px;
  border-radius: 7px;
}

.cadre-container {
  margin-top: 37px;
}
</style>
